import $ from 'jquery';

class Navigation {
    constructor() {
        this.resources = $(".s-c");

        if(this.resources) {
            this.setDefault();
            this.events();
        }
    }

    // events
    events() {
        this.resources.on('change', this.navigate.bind(this));
    }

    // methods
    setDefault() {
        this.resources.each(function () {
            if (($(".f-50-25").text()).includes($(this).val())) {
                $(this).prop("checked", true);
                $("#selected-value span").html($(this).val());
                return false;
            }
        });
    }

    navigate() {
        this.resources.each(function() {
            if($(this).is(":checked")) {
                $(location).attr('href', $(this).val().replace(/ /g,'-').replace(/\//g, ''));
                return false;
            }
        });
    }
}

export default Navigation;